var _defs, _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBathroomRemodeling = function SvgBathroomRemodeling(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "a",
    viewBox: "0 0 128 128"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".d-bathroom-remodeling,.e-bathroom-remodeling{fill:#fff;stroke:#0d72b9;stroke-width:3px;stroke-linecap:round;stroke-linejoin:round}.e-bathroom-remodeling{fill:none}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.55 108.11h-9.5l2.46-17.03 13.56 3.87zM92.69 108.11h9.5l-2.46-17.03-13.57 3.87zM13.05 43.77h14v8h-14z",
    className: "e-bathroom-remodeling"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8 33.08c0-6.86 5.58-12.43 12.44-12.43s12.43 5.58 12.43 12.43v1.18c0 .93-.75 1.68-1.68 1.68s-1.68-.75-1.68-1.68v-1.18c0-5-4.07-9.07-9.07-9.07s-9.07 4.07-9.07 9.07v10.75H17.8zm81.63 62.36a30.35 30.35 0 0 1-11.71 3.73c-2.46.28-47.78.28-50.22 0-4.12-.43-8.06-1.69-11.69-3.72A30.67 30.67 0 0 1 10.2 68.76V58.52h104.84v10.24c0 11.04-5.98 21.26-15.61 26.68",
    className: "d-bathroom-remodeling"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M116.79 61.77H8.44c-2.76 0-5-2.24-5-5s2.24-5 5-5h108.35c2.76 0 5 2.24 5 5s-2.24 5-5 5",
    className: "d-bathroom-remodeling"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 86.08,
    cy: 56.26,
    r: 23.97,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.25 53.07c-.7.72-1.21 1.54-1.54 2.42l4.45-.05c.35 0 .68.07.97.2a2.458 2.458 0 0 1 1.51 2.24c0 .13 0 .25-.03.38a2.44 2.44 0 0 1-2.4 2.1l-4.45.04a6.884 6.884 0 0 0 11.32 2.31 6.86 6.86 0 0 0 1.71-6.67l20.03-20.17c2.3.6 4.84-.03 6.62-1.84.7-.72 1.21-1.54 1.54-2.42l-4.45.05c-.35 0-.68-.07-.97-.2a2.458 2.458 0 0 1-1.51-2.24c0-.13 0-.25.03-.38a2.44 2.44 0 0 1 2.4-2.1l4.45-.04a6.884 6.884 0 0 0-11.32-2.31 6.86 6.86 0 0 0-1.71 6.66L76.87 51.23a6.86 6.86 0 0 0-6.62 1.85Z",
    style: {
      fill: "#fff",
      strokeMiterlimit: 10,
      stroke: "#0d72b9",
      strokeWidth: 3
    }
  }), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m83.49 35.26-5.74 5.92L97.57 61a4.075 4.075 0 0 0 5.44.28h0a4.06 4.06 0 0 0 .32-6.02l-19.85-20Z",
    className: "d-bathroom-remodeling"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M91.44 23.19s-5.86-5.44-14.07-3.22c-.93.25-1.78.73-2.52 1.34l-7.91 6.54s-1.43 1.55-.24 3.11c1.2 1.55-2.15 4.78-4.06 3.59l5.98 6.46s1.08-4.9 4.9-3.83l4.24 4 5.74-5.92-3.29-3.59s-1.2-4.66 8.37-7.29c0 0 3.35.72 2.87-1.2ZM69.94 42.46l-8.66-8.66a.954.954 0 0 0-1.36 0l-2.15 2.15c-.88.88-.88 2.31 0 3.19l6.77 6.77c.87.87 2.26.88 3.15.04l2.23-2.11c.39-.37.4-1 .02-1.38",
    className: "e-bathroom-remodeling"
  })));
};
export default SvgBathroomRemodeling;